import { Trans, useTranslation } from 'react-i18next'
import IconNoTokenResult from '~/assets/images/no-token-result.png'
import { StyledEmptyResult } from './styled'

const EmptySearchResult = () => {
  const { t, i18n } = useTranslation()
  const lang = i18n.resolvedLanguage === 'zh' ? 'zh-cn' : 'en-us'

  return (
    <StyledEmptyResult>
      <img src={IconNoTokenResult.src} />
      <p className="title">{t('no_search_result')}</p>
      <p>
        <Trans i18nKey="no_search_result_desc">
          {`代币未符合 Tokenlon 协议要求，了解 Tokenlon 代币白名单机制，<br />`}
          <a
            href={`https://support.tokenlon.im/hc/${lang}/articles/4417153399700`}
            target="_blank"
          >
            了解 Tokenlon 代币白名单机制
          </a>
        </Trans>
      </p>
    </StyledEmptyResult>
  )
}

export default EmptySearchResult
